import React, { useState } from 'react';
import { ExternalLink, Play } from 'lucide-react';
import LiteYouTubeEmbed from './LiteYouTubeEmbed';
import { tutorialsAPI } from '../utils/api';
import { trackTutorial } from '../hooks/useTutorials';

const vertical = 'w-full max-w-[340px] aspect-[9/16] rounded-2xl overflow-hidden bg-stone-900 shadow-lg';

const TikTokPlayer = ({ item, onPlay, testid }) => {
  const [loaded, setLoaded] = useState(false);
  if (loaded) {
    return (
      <iframe
        className={`${vertical} border-0`}
        src={`https://www.tiktok.com/embed/v2/${item.video_id}`}
        title={item.title}
        allow="encrypted-media; fullscreen"
        data-testid={testid}
      />
    );
  }
  return (
    <button
      type="button"
      onClick={() => { setLoaded(true); onPlay(); }}
      className={`${vertical} flex flex-col items-center justify-center gap-3 text-white hover:bg-stone-800 transition-colors`}
      data-testid={`${testid}-play`}
    >
      <span className="h-16 w-16 rounded-full bg-orange-500 flex items-center justify-center shadow-lg">
        <Play className="h-7 w-7 ml-1" fill="currentColor" />
      </span>
      <span className="text-sm font-semibold">Lancer la vidéo</span>
    </button>
  );
};

export const TutorialVideo = ({ item }) => {
  const testid = `tutorial-video-${item.id}`;
  const onPlay = () => trackTutorial(item.id, 'view');
  if (item.video_source === 'youtube') {
    return (
      <div className="w-full rounded-2xl overflow-hidden shadow-lg" onClickCapture={onPlay} data-testid={testid}>
        <LiteYouTubeEmbed videoId={item.video_id} title={item.title} />
      </div>
    );
  }
  if (item.video_source === 'upload') {
    return (
      <video
        className={`${vertical} object-cover`}
        src={tutorialsAPI.videoUrl(item.video_src)}
        poster={item.poster_src ? tutorialsAPI.videoUrl(item.poster_src) : undefined}
        controls
        playsInline
        preload="metadata"
        onPlay={onPlay}
        data-testid={testid}
      />
    );
  }
  if (item.video_id) return <TikTokPlayer item={item} onPlay={onPlay} testid={testid} />;
  return (
    <a
      href={item.video_url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onPlay}
      className={`${vertical} flex flex-col items-center justify-center gap-3 text-white hover:bg-stone-800 transition-colors`}
      data-testid={testid}
    >
      <ExternalLink className="h-8 w-8" />
      <span className="text-sm font-semibold">Voir sur TikTok</span>
    </a>
  );
};

export default TutorialVideo;
